import { type GetHookResponse } from '../hooks'
import { useScorables } from './scorable'
import { type AccountStatusId, isAccountStatusId, type ScorableMetricItem } from '@terros/common'
import { useMemo } from 'react'

type ScorableAccountStatusItem = Omit<ScorableMetricItem, 'field'> & {
  field: AccountStatusId
}

export function useScorableAccountStatus(): GetHookResponse<ScorableAccountStatusItem[]> {
  const { data, ...rest } = useScorables()
  const accountStatuses: ScorableAccountStatusItem[] = useMemo(() => {
    if (!data) return []
    return data.filter(isScorableAccountStatus)
  }, [data])

  return { data: accountStatuses, ...rest }
}

const isScorableAccountStatus = (m: ScorableMetricItem): m is ScorableAccountStatusItem => {
  return isAccountStatusId(m.field)
}
